<template>
  <div v-if="visible" class="overlay-loading">
    <div class="spinner"></div>
    <p>{{ message }}</p>
  </div>
</template>

<script lang="ts" setup>
/**
 * Capa de carga que bloquea la interacción durante una operación larga.
 *
 * Relevante porque varias operaciones del sistema (informes, sincronización de
 * formularios) tardan decenas de segundos.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = defineProps<{
  visible: boolean
  message?: string
}>()
</script>

<style scoped>
.overlay-loading {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(2px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  font-family: var(--font-family);
}

.overlay-loading p {
  font-size: var(--font-size-base);
  font-weight: 500;
  color: var(--text-secondary);
  letter-spacing: 0.01em;
}

.spinner {
  border: 5px solid #eee;
  border-top: 5px solid #3b82f6;
  border-radius: 50%;
  width: 44px; height: 44px;
  animation: spin 0.8s linear infinite;
  margin-bottom: var(--space-base);
}

@keyframes spin {
  100% { transform: rotate(360deg); }
}
</style>
